let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("11nfS")).then(() => parcelRequire('fZ0Zm'));